import React, { Component } from 'react';
import glamorous from 'glamorous';
import { FormattedMessage } from 'react-intl';
import { get, filter } from 'lodash';
import { NonIdealState } from '@blueprintjs/core';
import DetailsLeft from './details-left';
import DetailsRight from './details-right';

class RecallDetailsView extends Component {
  componentDidMount() {
    const { loadRecallDetails, params, locale } = this.props;
    loadRecallDetails({ ...params, locale });

    //I was rather thinking of : displaying the first option as “French” when we are in French interface,
    // etc., no matter what is the language of recall.  And displaying always the Google button,
    // up to user to decide if he wants to ask for a translation or not.

    const recallLanguage = get(params, 'uri', '').indexOf('/Recall/FR/') > -1 ? 'fr' : 'en';

    window.googleTranslateElementInit = function () {
      new window.google.translate.TranslateElement({
        pageLanguage: recallLanguage,
        includedLanguages: filter(['en','es','fr','ja','ko'], x => x !== recallLanguage).join(','),
        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        multilanguagePage: true,
      }, 'google_translate_element');
    };

    const script = document.createElement("script");
    script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    document.body.appendChild(script);
  }

  componentWillUnmount() {
    const translateIframe = document.querySelector('iframe:first-of-type');
    const innerDoc = get(translateIframe, 'contentDocument') || get(translateIframe, 'contentWindow.document');
    if (innerDoc) {
      const closeTranslationBar = innerDoc.getElementsByClassName("goog-close-link");
      if (closeTranslationBar.length && closeTranslationBar[0]) {
        closeTranslationBar[0].click();
      }
    }
  }

  render() {
    const {
      recall,
      onRecallTagSelect,
      error,
      isFething,
      config,
    } = this.props;

    if (isFething) {
      return (
        <div className="container">
          <h2>
            Loading...
          </h2>
        </div>
      );
    }

    if (error) {
      return (
        <div className="container">
          <NonIdealState
            title={<FormattedMessage id="details.error.title"/>}
            description={<FormattedMessage id="details.error.description"/>}
            visual="pt-icon-error"
          />
        </div>
      );
    }

    return (
      <div className="container">
        <div className="row name">
          <div className="col-xs-12">
            <h1>
              {get(recall, 'product.name')}
            </h1>
            <glamorous.Div
              id="google_translate_element"
              css={{
                '& .goog-te-gadget-simple': {
                  fontSize: '18px',
                }
              }}
            />
          </div>
        </div>
        <hr/>
        <div className="row">
          <DetailsLeft recall={recall}/>
          <DetailsRight recall={recall} onRecallTagSelect={onRecallTagSelect} config={config}/>
        </div>
      </div>
    );
  }
}

export default RecallDetailsView;



// WEBPACK FOOTER //
// ./src/views/recall-details/index.js